document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-variant-id]');
    if (target) {
        const variantId = target.getAttribute('data-variant-id');
        const productItem = target.closest('.custom_product_item');
				
        if (productItem) {
					const correctBadges = productItem.querySelector(`.variant-badges[data-badges-variant="${variantId}"]`);

					productItem.querySelectorAll('.variant-badges').forEach(b => {
						if(correctBadges && correctBadges !== b) {
							b.style.display = 'none'
						}
					});


            if (correctBadges) correctBadges.style.display = 'block';
        }
    }
});
window.addEventListener('DOMContentLoaded', () => {
    function setupBadgesHover(container) {
        const swiper = container.querySelector('.custom_product_item-swiper');
        const badges = container.querySelectorAll('.variant-badges');
        if (!swiper || container.dataset.hoverReady === "true") return;
        const wrapper = swiper.querySelector('.swiper-wrapper');
        if (!wrapper || wrapper.children.length <= 1) return;
        swiper.addEventListener('mouseenter', () => badges.forEach(badge => badge.style.visibility = 'hidden'));
        swiper.addEventListener('mouseleave', () => badges.forEach(badge => badge.style.visibility = 'visible'));
        container.dataset.hoverReady = "true";
    }
    document.querySelectorAll('.custom_product_item-with-slider').forEach(setupBadgesHover);
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (!(node instanceof HTMLElement)) return;
                if (node.matches('.custom_product_item-with-slider')) {
                    setupBadgesHover(node);
                } else {
                    node.querySelectorAll?.('.custom_product_item-with-slider')?.forEach(setupBadgesHover);
                }
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });
});
